function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// @ts-nocheck
import React from 'react';
import nl2br from "../utils/nl2br";
import matchParser from "./match_parser";
var AutoLink = /*#__PURE__*/function (_React$Component) {
  _inherits(AutoLink, _React$Component);
  var _super = _createSuper(AutoLink);
  function AutoLink() {
    _classCallCheck(this, AutoLink);
    return _super.apply(this, arguments);
  }
  _createClass(AutoLink, [{
    key: "prepareElements",
    value: function prepareElements(matches, text) {
      var _this = this;
      var elements = [];
      var lastIndex = 0;
      matches.forEach(function (match) {
        if (match.position.start !== 0) {
          elements.push( /*#__PURE__*/React.createElement('span', {}, nl2br(text.slice(lastIndex, match.position.start), true)));
        }
        elements.push( /*#__PURE__*/React.createElement('a', Object.assign({}, {
          href: match.getAnchorHref()
        }, _this.props.linkProps), nl2br(match.getAnchorText(), true)));
        lastIndex = match.position.end;
      });
      if (lastIndex < text.length) {
        elements.push( /*#__PURE__*/React.createElement('span', {}, nl2br(text.slice(lastIndex), true)));
      }
      return elements;
    }
  }, {
    key: "truncate",
    value: function truncate(items) {
      var _this2 = this;
      if (!this.props.maxLength) return items;
      var elements = [];
      var length = 0;
      items.some(function (el) {
        length += el.props.children.length;
        if (length > _this2.props.maxLength) {
          var truncatedText = el.props.children.slice(0, -(length - _this2.props.maxLength));
          elements.push( /*#__PURE__*/React.cloneElement(el, {}, truncatedText));
          return true; // stop iterating through the elements
        }

        elements.push(el);
      });
      return elements;
    }

    /*
     * Generate unique keys for each of the elements.
     * The key will be based on the index of the element.
     */
  }, {
    key: "keyElements",
    value: function keyElements(elements) {
      return elements.map(function (el, index) {
        return /*#__PURE__*/React.cloneElement(el, {
          key: index
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var text = this.props.text || '';
      var keyedElements = this.keyElements(this.truncate(this.prepareElements(matchParser(text, this.props.disableUrlStripping), text)));
      return /*#__PURE__*/React.createElement('span', {}, keyedElements);
    }
  }]);
  return AutoLink;
}(React.Component);
export default AutoLink;